import { ITypeOption } from "@/components/excel/schema/definiens/bizType";
import { CurrencySelector } from "@/components/excel/schema/selector/currency";
import { SexSelector } from "@/components/excel/schema/selector/sex";
import {
  CurrencyMode,
  MoneyMode,
  OtherMode,
  SexMode,
} from "@/components/excel/schema/value/mode/other";

const base = 100;
export const OtherOption: ITypeOption = {
  value: base + 1,
  text: "其他",
  mode: OtherMode,
};
export const SexOption: ITypeOption = {
  value: base + 2,
  text: "性别",
  mode: SexMode,
  selector: SexSelector,
};
export const CurrencyOption: ITypeOption = {
  value: base + 3,
  text: "货币",
  mode: CurrencyMode,
  selector: CurrencySelector,
};
export const MoneyOption: ITypeOption = {
  value: base + 4,
  text: "钱",
  mode: MoneyMode,
};
